import { render, staticRenderFns } from "./BankTransactionList.vue?vue&type=template&id=5bb1251c&"
import script from "./BankTransactionList.vue?vue&type=script&lang=js&"
export * from "./BankTransactionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports